module.exports = __webpack_public_path__ + "img/flair-selector-arrow-down.45dab461.svg";